import React from 'react';

import BaseComponent from '../../../baseClasses/BaseComponent';
import dataModel from '../../../models/DataModel';

import UserSettings from '../../../components/UserSettings';
import './UserSettingsModal.scss';

class UserSettingsModal extends BaseComponent {
  render() {
    const { currentUser, closeSettings } = this.props;
    return (
      <div className='UserSettingsModal'>
        <UserSettings 
          currentUser={currentUser}
          isMobile={dataModel.mobileBridge.isMobile}
          closeSettings={closeSettings}
        />
      </div>
    );
  }
}
export default UserSettingsModal;



// WEBPACK FOOTER //
// ./src/components/modals/UserSettingsModal/index.js